// extracted by mini-css-extract-plugin
export default {"container":"Ar-z","heading":"Br-z","text":"Cr-z","info":"Dr-z","link":"Er-z","fullMaxWidth":"Fr-z"};